<template>
  <div class="home-container">
    <!-- <div class="homeTip">
      <img src="../../assets/images/laba.svg" style="width:20px" />
      <div>
        <span style="font-weight: bolder;">【重要】</span
        >（1）双11大促期间短信发送时间：10月31日-11月1日 09:00-24:00，11月2日-11月9日 09:00-22:00，11月10日、11月11日 09:00-24:00，11月12日起恢复正常，即09:00-20:00；

       <div style="margin-left:1px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）10月25日-11月11日大促期频控规则：同一商家2天内给同一手机号发送营销短信条数不超过 1 条;每个手机号每 1 天只能收到 8条京东商家短信,每 2 天只能收到 15 条京东商家短信；</div>   

      <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（3）双11大促期间审核额度：超过5W人群活动需要官方人工审核，每工作日18:00审核，10月31日、11月10日定时增加审核时间。建议商家提前创建活动。</div>  
      </div>
    </div> -->
    <el-row class="home-top" :gutter="20">
      <!-- 核心数据 -->
      <page-core-data></page-core-data>
      <!-- 店铺概括 -->
      <page-shop></page-shop>
    </el-row>
    <el-row class="home-content" :gutter="20">
      <!-- 营销效果分析 -->
      <page-analysis></page-analysis>
      <!-- 会员转化 -->
      <!-- <page-doubt></page-doubt> -->
      <!-- 公告 -->
      <page-notice></page-notice>
    </el-row>
    <!-- <el-row class="home-bottom" :gutter="20"> -->
    <!-- 会员数分布情况 -->
    <!-- <page-member></page-member> -->

    <!-- 订单金额分布情况情况 -->
    <!-- <page-order-money></page-order-money> -->
    <!-- <page-banner></page-banner> -->
    <!-- </el-row> -->
    <el-row class="home-bottom" :gutter="20">
      <!-- 底部重点人群、复购 -->
      <page-footModule></page-footModule>
      <!-- <page-repurchase></page-repurchase> -->
      <page-transform></page-transform>
    </el-row>

    <!-- 系统提示 -->
    <system-dialog v-if="tipVisible" @close="closeSystemTip" :tipType="tipType"></system-dialog>

    <!-- 公告 -->
    <!-- <notiece-dialog v-if="showNotice" @close="handleClose"></notiece-dialog> -->

    <!-- 618活动弹框 -->
    <!-- <el-dialog
      :close-on-click-modal="false"
      :visible.sync="coupon11Visible"
      width="800px"
      class="dialong_transition">
      <div>
        <img src="@/assets/images/618软件内弹窗 1.png"
                         alt
                         style="width:100%">
        <img class="circle" @click="localToday" src="@/assets/images/btn_关闭.png" alt="" >
      </div>
    </el-dialog> -->
    <!-- 公告弹窗 -->
    <!-- <el-dialog
      :visible.sync="announcementDialog"
      class="liT"
      title="【必看】短信通道升级通知"
      width="750px"
      :before-close="localToday"
      :close-on-click-modal="false"
      center
    >
      <p class="litTil">
        ——针对订单关怀（24日升级）、客户营销-自动化营销模块（1月7日升级）
      </p>
      <p>尊敬的商家朋友，您好！</p>
      <p>
        应京东官方要求，进一步加强平台用户信息安全性，我们将于12月24日（周四）及1月7日（周四）夜间，升级短信通道，由第三方通道切换成京东官方通道，<span
          style="color: #fe4d45"
          >具体影响如下：</span
        >
      </p>
      <p class="smallTil">1、需重新设置启用关怀任务和自动化营销任务：</p>
      <p class="yelloTil">
        现有进行中的任务会在此次功能上线后由系统全部关闭，届时需您重新设置关怀任务，包括：催付催评等物流通
      </p>
      <p class="yelloTil" style="width:250px">  
        知类，首购复购有礼等自动化营销类。
      </p>
      <p class="smallTil">2、短信内容编辑模板化：</p>
      <p>
        不再支持自定义编辑内容，需统一采用短信模板，如需编辑非模板内容，需提前联系业务员提交京东申请审批。
      </p>
      <p class="smallTil">3、下线手机号码信息导入/查询/导出功能：</p>
      <p>所有页面的会员信息/订单信息中不再返回明文手机号；</p>
     
      <p class="yelloTil">
        注意：届时旧版云短信也将关闭，全面使用新版，不可切换回旧版；改造后不支持会员账单及活动码功能，届时
      </p>
      <p class="yelloTil2">将会下线。</p>
       <p class="smallTil">4、此次改造后指定号码发送以及变量短信发送将不再支持效果分析；营销汇总分析不再支持添加新的分析任务；</p>
      <p class="smallTil2">
        由于此次变更给您带来的不便我们深表歉意，感谢您的理解、支持和配合，如有问题可随时联系客服沟通处理，谢谢！
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="localToday()"
          >确 定</el-button
        >
      </span>
    </el-dialog> -->

    <!-- 调查问卷跳转弹窗 -->
    <!-- <div class="box" v-if="centerDialog">
      <div class="liTwo">
        <div class="close" @click="closeCenterDialog"></div>
        <div class="litBtn" @click="changeFormNew"></div>
      </div>
    </div> -->

    <!-- 调查问卷 -->
    <!-- <el-dialog
      title="新版云短信CRM使用调研"
      :visible.sync="dialogFormNew"
      width="845px"
      class="backgrou"
      center
      top="50px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div slot="title" class="dialog-title">&nbsp;</div>
      <div class="guanbi" @click="guanbiDialog"></div>
      <el-form :model="questionnaire" class="quesFrom">
        <div class="questionnaire">
          <p class="span">您的声音很有力量，我们渴望您的反馈！</p>
          <p class="span">
            填写完成后截图联系客服/专属顾问可领取<span
              style="color: #ff3a27; font-size: 20px; font-weight: 600"
            >
              200 </span
            >条短信奖励哦~
          </p>
        </div>
        <el-form-item>
          <p class="title1">
            1、针对新版云短信CRM，您觉得对网站配色、布局是否满意？（主题色-红色，搭配色-紫色）
            <span class="xinghao">*</span>
          </p>
          <el-radio-group
            v-model="questionnaire.answerOne"
            style="margin-left: 24px"
          >
            <el-radio label="满意"></el-radio>
            <el-radio label="不满意"> </el-radio>
          </el-radio-group>
          <br />
          <el-input
            class="input"
            v-model="inputOne"
            placeholder="请描述不满意的原因"
            v-if="questionnaire.answerOne == '不满意'"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <p class="title">
            2、针对新版云短信CRM，您觉得哪些页面美观度需改进？
            <span class="xinghao">*</span>
          </p>
          <el-checkbox-group
            v-model="questionnaire.answerTwo"
            style="margin-left: 24px"
          >
            <el-checkbox style="margin-top: -8px" label="首页"></el-checkbox>
            <el-checkbox
              style="margin-top: -8px"
              label="订单关怀"
            ></el-checkbox>
            <el-checkbox
              style="margin-top: -8px"
              label="客户营销-精准营销-客户分群"
            ></el-checkbox>
            <el-checkbox
              style="margin-top: -8px"
              label="客户营销-精准营销-精准营销"
            ></el-checkbox>
            <el-checkbox
              style="margin-top: -8px"
              label="客户营销-精准营销-会员发送"
            ></el-checkbox>
            <el-checkbox
              style="margin-top: -8px"
              label="数据分析-客户分析"
            ></el-checkbox>
            <el-checkbox
              style="margin-top: -8px"
              label="数据分析-客户分析（自营）"
            ></el-checkbox>
            <el-checkbox
              style="margin-top: -8px"
              label="数据分析-RFM分析"
            ></el-checkbox>
            <el-checkbox
              style="margin-top: -8px"
              label="后台管理-短信管理-短信充值"
            ></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <p class="title">
            3、您进入新版系统时页面会卡顿或者切换哪些页面时会卡顿呢？
            <span class="xinghao">*</span>
          </p>
          <el-radio-group
            v-model="questionnaire.answerThree"
            style="margin-left: 24px"
          >
            <el-radio label="卡顿"></el-radio>
            <el-radio label="不卡顿"></el-radio>
          </el-radio-group>
          <br />
          <el-input
            class="input"
            v-model="inputTwo"
            placeholder="请描述哪些页面卡顿"
            v-if="questionnaire.answerThree == '卡顿'"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <p class="title">
            4、目前新版云短信CRM的功能是否能满足店铺的运营需求？
            <span class="xinghao">*</span>
          </p>
          <el-radio-group
            v-model="questionnaire.answerFour"
            style="margin-left: 24px"
          >
            <el-radio label="满足"></el-radio>
            <el-radio label="不满足"></el-radio>
          </el-radio-group>
          <br />
          <el-input
            class="input"
            v-model="inputThree"
            placeholder="请描述您的需求"
            v-if="questionnaire.answerFour == '不满足'"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <p class="title">
            5、新旧版云短信对比，您更愿意使用新版还是旧版？
            <span class="xinghao">*</span>
          </p>
          <el-radio-group
            v-model="questionnaire.answerFive"
            style="margin-left: 24px"
          >
            <el-radio label="新版"></el-radio>
            <el-radio label="旧版"></el-radio>
          </el-radio-group>
          <br />
          <el-input
            class="input"
            v-model="inputFour"
            placeholder="请填写使用旧版的原因"
            v-if="questionnaire.answerFive == '旧版'"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <p class="title">
            6、针对新版云短信您最想吐槽的点或建议？
            <span class="xinghao">*</span>
          </p>
          <el-input
            style="margin-left: 24px; width: 692px"
            type="textarea"
            :rows="4"
            resize="none"
            placeholder="请输入内容"
            v-model="questionnaire.answerSix"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <button class="butAdd" @click="submit">提 交</button>
      </div>
    </el-dialog> -->

    <!-- 悬浮图标 -->
    <!-- <div class="floatNew" v-if="dialogNee">
      <button class="floatBtn" @click="dialogNeCli">点击我</button>
    </div> -->
    <!-- <div class="tanchuanBG" v-if="visibleXitou">
      <div class="img">
        <img src="@/assets/images/tanchuan.png" alt="" />
        <div class="gb" @click="imgGB()">
          <img src="@/assets/images/tanchaun_gb.png" alt="" />
        </div>
      </div>
    </div> -->
    <!-- <el-dialog :close-on-click-modal="false" :visible.sync="isMember" width="600px" class="dialong_transition">
      <div style="display: flex;">
        <img src="@/assets/images/jd_11_img.png" alt style="width:100%" />
        <img class="circle3" @click="tbClose" src="@/assets/images/btn_关闭.png" alt="" width="29" height="29" />
      </div>
    </el-dialog> -->
    <el-dialog
      title="系统公告"
      :visible.sync="isPopVisiv"
      width="800px"
      :before-close="beforeClose"
      :class="{ dialong_transition: popItem.type == 0 }"
      :close-on-click-modal="false"
    >
      <!-- type == 0  图片弹窗 -->
      <div
        style="display: flex; justify-content: center"
        v-if="popItem.type == 0"
      >
        <div style="position: relative">
          <img
            @click="handleLink()"
            class="pointer"
            :src="popItem.pcPic"
            alt
            style="max-width: 100%; margin: 0 auto; margin-top: 38px"
          />
          <img
            class="pointer"
            style="position: absolute"
            @click="beforeClose"
            src="@/assets/images/btn_关闭.png"
            alt=""
            width="29"
            height="29"
          />
        </div>
      </div>
      <!-- type == 1  文字弹窗 -->
      <template v-else>
        <div
          style="height: 500px; overflow-y: auto; padding-bottom: 20px"
          v-html="popItem.richText"
        ></div>
      </template>
    </el-dialog>
    
    <yearReport 
      v-if="isNeedReport"
      ref="yearReport"
      :isShow="showYearReport" 
      @close="showYearReport=false"
      @show="showYearReport=true"
    />

    <shop-common-components type="NPS" :custom-params.prop="customParams"></shop-common-components> 
  </div>
</template>

<script>
import {
  versionPermissions,
  getPrecisionJdSuffixListHome,
} from "@/api/homePage";
import {
  getSellerInfo,
  validPopups,
  displayRecord,
} from "@/api/sellerController";
import shieldList from "@/utils/shieldList.json";
import { submitQuestionnaire, inspectQues } from "@/api/homePage";
import pageCoreData from "./page-core-data";
import pageShop from "./page-shop";
import pageAnalysis from "./page-analysis";
import pageMember from "./page-member";
import pageNotice from "./page-notice";
import pageFootModule from "./page-footModule";
import pageDoubt from "./page-doubt";
import pageMemberConversion from "./page-member-conversion";
import pageOrderMoney from "./page-order-money";
import pageTransform from "./page-transform";
import systemDialog from "@/components/system-dialog";
import notieceDialog from "@/components/notice";
import yearReport from "@/components/year-report/index.vue";
import { getAnnualReport } from "@/api/homePage"
// import pageBanner from './page-banner'
// import pageRepurchase from './page-repurchase'

export default {
  name: "home",
  components: {
    pageCoreData,
    pageShop,
    pageAnalysis,
    pageMember,
    pageNotice,
    pageFootModule,
    pageDoubt,
    pageMemberConversion,
    pageOrderMoney,
    pageTransform,
    systemDialog,
    notieceDialog,
    yearReport,
    // pageBanner,
    // pageRepurchase
  },
  created() {
    // 调用埋点接口
    this.buriedPoint(1, "首页", "首页", "首页");
    
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    loginUserInfo() {
      return this.$store.getters.loginUserInfo;
    },
  },
  watch: {
    venderType(newval) {
      if (newval == false && this.isTodayShow) {
        // this.announcementDialog = true;
      }
    },
    loginUserInfo(newval) {
      this.handleShowNotice();
    },
  },

  mounted() {
    getPrecisionJdSuffixListHome()
      .then(() => {})
      .catch(() => {});
    getSellerInfo().then((res) => {

      console.log("loginUserInfo",res.data.openIdentifyingCode)
      this.tipType = res.data.openIdentifyingCode || 1
      if(res.data.openIdentifyingCode == 0){
        this.tipVisible = false
      }else{
        this.tipVisible = true
      }
      if (res.data.mobile && res.data.mobile.length > 0) {
        this.visibleXitou = sessionStorage.getItem("visibleXitou")
          ? true
          : false;
        this.pupupList();
        this.customParams = {
          nps: {
            npsNodeIdLv1: 'CJ_LISTEN_JM_ISV',
            npsNodeIdLv2: 'CJ_LISTEN_JM_ISV_CDXCRM',
            token: res.data.encryptedToken, // 传入token证明是isv商家
            npsStatus: true,
            placement: 'right',
          },
        }
      }
      // 此处判断绑定手机号与年度报告弹窗优先级
      if (!res.data.isBindPhone) {
        this.getAnnualReport()
      }
    });
    this.tbMember();
    this.showNotice = sessionStorage.getItem("showNotice") ? true : false;
    window.JM_SHOP_MENU.on('handleNpsStatus', () => {
      console.log('NPS completed');
    });

  },
  data() {
    return {
      customParams: {},
      isPopVisiv: false,
      isOpenYearReport: true, // 是否开启年终报告
      isNeedReport: false, // 是否需要展示年终报告
      showYearReport: true, // 年终报表
      popItem: {},
      popList: [],
      popIndex: 0,
      isEndTime: false,
      isMember: false,
      visibleXitou: false,
      showNotice: false, // 系统公告弹出
      isTodayShow: false, // 一天显示一次
      // announcementDialog: false,
      // centerDialog: false,
      // dialogFormNew: false,
      // dialogNee: false,
      // questionnaire: {
      //   answerTwo: [],
      // },
      // inputOne: "",
      // inputTwo: "",
      // inputThree: "",
      // inputFour: "",
      tipVisible: false,
      tipType:1,
      coupon11Visible: false, // 双十一优惠券弹窗

      today: new Date().getMonth() + 1 + "--" + new Date().getDate(),
    };
  },
  methods: {
    closeSysDialog() {
      this.isPopVisiv = false;
    },

    checkSysDialog() {
      if (this.$store.state.yearReportStatus) {
        this.isPopVisiv = false;
      }
      if (this.isPopVisiv && !this.$store.state.yearReportStatus) {
        this.isPopVisiv = true;
      }
    },

    async getAnnualReport() {
      return // 下架年度报告
      const res = await getAnnualReport()
      if(!res.data || !res.data.marketingSmsNum) {
        this.isNeedReport = false
      } else {
        this.isNeedReport = true
      }
    },

    handleLink() {
      if (this.popItem.pcUrl) {
        window.open(this.popItem.pcUrl, "_blank");
      }
    },
    pupupList() {
      validPopups().then((res) => {
        if (res.data && res.data.length > 0) {
          this.popItem = res.data[0];
          this.popList = res.data;
          this.popIndex = 0;
          this.isPopVisiv = sessionStorage.getItem("isPopVisiv") ? true : false;
          this.checkSysDialog()
        }
      });
    },
    beforeClose() {
      displayRecord(this.popItem.id);
      if (this.popList.length == this.popIndex + 1) {
        this.isPopVisiv = false;
        sessionStorage.removeItem("isPopVisiv");
      } else {
        this.isPopVisiv = false;
        setTimeout(() => {
          this.popIndex = this.popIndex + 1;
          this.popItem = this.popList[this.popIndex];
          this.isPopVisiv = true;
          console.log(this.isPopVisiv, 4444444444);
        }, 500);
      }
    },
    tbMember() {
      const now = new Date().getTime();
      const end = new Date("2022 11 12 00:00:00").getTime();
      if (now > end) {
        this.isEndTime = true;
        this.isMember = false;
      }
      if (!this.isEndTime) {
        const a = new Date().getMonth() + "-" + new Date().getDate();
        if (localStorage.getItem(a)) {
          this.isMember = false;
        } else {
          this.isMember = true;
        }
      }
      const e = new Date().getMonth();
      const b = new Date().getDate();
      const c = e + b;
      if (this.isMember) {
        const a = new Date().getMonth() + "-" + new Date().getDate();
        setTimeout(() => {
          this.isMember = false;
          localStorage.setItem(a, this.isMember);
        }, 10000);
      }
    },
    tbClose() {
      const a = new Date().getMonth() + "-" + new Date().getDate();
      this.isMember = false;
      localStorage.setItem(a, this.isMember);
    },
    // 关闭弹窗
    imgGB() {
      sessionStorage.removeItem("visibleXitou");
      this.visibleXitou = false;
    },
    handleShowNotice() {
      var date = new Date();
      if (date.getTime() > new Date("2021/07/10 23:59:59").getTime()) {
        return;
      }
      var sellerNick = this.loginUserInfo.sellerNick;
      if (sellerNick) {
        var localNotice = localStorage.getItem("noticeNick");
        if (!localNotice || sellerNick != localNotice) {
          this.showNotice = true;
        }
      }
    },
    handleClose() {
      this.showNotice = false;
      var sellerNick = this.loginUserInfo.sellerNick;
      localStorage.setItem("noticeNick", sellerNick);
      sessionStorage.removeItem("showNotice");
    },
    showActive() {
      if (
        shieldList.shopName.includes(this.$store.state.loginUserInfo.sellerNick)
      ) {
        return;
      }
      this.handleIsTodayShow();
      if (this.isTodayShow) {
        this.coupon11Visible = true;
        setTimeout(() => {
          this.localToday();
        }, 10000);
      }
    },
    handleIsTodayShow() {
      // 设置判断今天是否显示过该弹窗
      var date = new Date();
      var saveToday = localStorage.getItem(
        "saveToday" + this.$store.getters.loginUserInfo.venderId
      );

      if (!(saveToday && saveToday == this.today)) {
        this.isTodayShow = true;
      } else {
        this.isTodayShow = false;
      }
    },
    localToday() {
      this.coupon11Visible = false;
      localStorage.setItem(
        "saveToday" + this.$store.getters.loginUserInfo.venderId,
        this.today
      );
    },

    // closeCenterDialog() {
    //   this.centerDialog = false;
    //   this.dialogNee = true;
    // },
    // dialogNeCli() {
    //   this.dialogFormNew = true;
    //   this.dialogNee = false;
    // },
    // guanbiDialog() {
    //   this.dialogFormNew = false;
    //   this.dialogNee = true;
    // },
    closeSystemTip() {
      // console.log(this.popList.length > 0, 3333333);
      this.tipVisible = false;
      this.visibleXitou = sessionStorage.getItem("visibleXitou") ? true : false;
      this.pupupList();
      if (this.isOpenYearReport) {
        this.getAnnualReport()
      }
    },
    // changeFormNew() {
    //   this.centerDialog = false;
    //   this.dialogFormNew = true;
    // },
    // submit() {
    //   let form = {
    //     answerOne: this.questionnaire.answerOne,
    //     answerTwo: this.questionnaire.answerTwo.join(","),
    //     answerThree: this.questionnaire.answerThree,
    //     answerFour: this.questionnaire.answerFour,
    //     answerFive: this.questionnaire.answerFive,
    //     answerSix: this.questionnaire.answerSix,
    //   };
    //   if (this.questionnaire.answerOne == "不满意") {
    //     form.answerOne = this.questionnaire.answerOne + "," + this.inputOne;
    //   }
    //   if (this.questionnaire.answerThree == "卡顿") {
    //     form.answerThree = this.questionnaire.answerThree + "," + this.inputTwo;
    //   }
    //   if (this.questionnaire.answerFour == "不满足") {
    //     form.answerFour = this.questionnaire.answerFour + "," + this.inputThree;
    //   }
    //   if (this.questionnaire.answerFive == "旧版") {
    //     form.answerFive = this.questionnaire.answerFive + "," + this.inputFour;
    //   }
    //   if (!this.questionnaire.answerOne) {
    //     this.$message.warning("第一题不能为空");
    //     return;
    //   }
    //   if (this.questionnaire.answerTwo.length == 0) {
    //     this.$message.warning("第二题不能为空");
    //     return;
    //   }
    //   if (!this.questionnaire.answerThree) {
    //     this.$message.warning("第三题不能为空");
    //     return;
    //   }
    //   if (!this.questionnaire.answerFour) {
    //     this.$message.warning("第四题不能为空");
    //     return;
    //   }
    //   if (!this.questionnaire.answerFive) {
    //     this.$message.warning("第五题不能为空");
    //     return;
    //   }
    //   if (!this.questionnaire.answerSix) {
    //     this.$message.warning("第六题不能为空");
    //     return;
    //   }
    //   submitQuestionnaire(form)
    //     .then((res) => {
    //       if (res && res.code == 1) {
    //         this.$message.success("提交成功");
    //         this.dialogFormNew = false;
    //         this.dialogNee = false;
    //       } else {
    //         this.$message.error(res.message);
    //       }
    //     })
    //     .catch((res) => {});
    // },
  },
};
</script>

<style scoped lang="scss">
.homeTip {
  background: #fffaee;
  padding: 16px 10px;
  margin: 0 10px 10px;
  color: #ffbd3c;
  line-height: 20px;
  display: flex;
  align-items: start;
  // &::before {
  //   content: "";
  //   width: 20px;
  //   height: 20px;
  //   display: block;
  //   background: url("../../assets/images/laba.svg") no-repeat;
  // }
}

@keyframes mymove {
  0% {
    transform: scale(0);
    /*开始为原始大小*/
  }

  100% {
    transform: scale(1);
  }
}

.tanchuanBG {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  width: 100%;
  height: 100vh;
  // background: #000;
  background: rgba(0, 0, 0, 0.7);
  // opacity: 0.7;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;

  .img {
    display: inline-flex;
    position: relative;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    animation: mymove 1s;

    .gb {
      width: 40px;
      height: 40px;
      top: 0px;
      right: 0px;
      position: absolute;
      cursor: pointer;
    }
  }
}

/deep/.dialong_transition {
  .el-dialog {
    background: transparent;

    // box-shadow: 0 0px 0px rgba(0, 0, 0, 0.3);
    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      background: transparent;
    }
  }

  .circle {
    color: #dedddc;
    // border: 2px solid #dedddc;
    // width: 36px;
    // height: 36px;
    text-align: center;
    line-height: 28px;
    border-radius: 50%;
    display: inline-block;
    font-size: 26px;
    position: absolute;
    right: 6px;
    top: 58px;
    cursor: pointer;
  }
}

/deep/.el-dialog__header {
  // padding: 25px 0;
  // height: 90px;
  // border: none;
}

/deep/.el-dialog__body {
  padding-bottom: 0px;
}

/deep/.el-dialog__footer {
  padding-bottom: 30px;
}

.home-container {
  box-sizing: border-box;
  padding: 20px 10px 20px 16px;
  min-width: 1280px;

  .home-top {
    // height: 196px;
    height: 240px;
    margin: 0 !important;
  }

  .home-content {
    height: 460px;
    margin: 20px 0 0 0 !important;

    @media screen and (max-width: 1540px) {
      height: 440px;
    }

    @media screen and (max-width: 1366px) {
      height: 420px;
    }

    @media screen and (max-width: 1300px) {
      height: 400px;
    }
  }

  .home-bottom {
    margin: 20px 0 0 0 !important;
  }

  .backgrou {
    .dialog-title {
      background: url("../../assets/images/bg.png") no-repeat center;
      height: 69px;
    }

    .guanbi {
      background: url("../../assets/images/btn_gb.png") no-repeat center;
      float: right;
      margin: -140px 5px 0 0;
      height: 76px;
      width: 40px;
      cursor: pointer;
    }

    .quesFrom {
      margin: 0 40px;

      .questionnaire {
        background: #f7f8fe;
        padding: 10px 15px;
        border-radius: 6px;

        .span {
          margin-bottom: 2px;
          color: #6a4bff;
          font-size: 14px;
        }
      }

      .title {
        color: #000;
        margin-top: -10px;
        font-weight: 600;

        .xinghao {
          color: #ff3a27;
        }
      }

      .title1 {
        color: #000;
        font-weight: 600;
        margin-top: 10px;

        .xinghao {
          color: #ff3a27;
        }
      }

      .input {
        margin: 4px 0 0 20px;
        width: 300px;
      }
    }

    .butAdd {
      margin-top: -20px;
      width: 160px;
      height: 40px;
      background: #6a4bff;
      border-radius: 20px;
      color: #ffffff;

      &:hover {
        border-color: #6a4bff;
        background: #836aff;
      }
    }
  }

  .liT {
    .litTil {
      font-size: 20px;
      // text-align: center;
      font-weight: bold;
      margin-bottom: 20px;
    }

    p {
      margin-bottom: 8px;
      line-height: 26px;
    }

    .smallTil {
      font-size: 16px;
      margin: 10px 0;
      font-weight: bold;
      color: #fe4d45;
    }

    .smallTil2 {
      font-size: 16px;
      margin: 10px 0;
      font-weight: bold;
    }

    .impTil {
      color: #fe4d45;
    }

    .yelloTil {
      background: #ffff00;
      padding: 4px;
      // width: 425px;
    }

    .yelloTil2 {
      background: #ffff00;
      padding: 4px;
      width: 80px;
    }
  }

  .box {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 3000;

    .liTwo {
      position: absolute;
      background: url("../../assets/images/datangc.png") no-repeat center;
      z-index: 3001;
      top: 27%;
      left: 37%;
      width: 504px;
      height: 460px;

      .litBtn {
        cursor: pointer;
        height: 55px;
        width: 190px;
        margin: 355px 0 0 150px;
        // border: 1px solid #009dd9;
        border-radius: 22px;
      }

      .close {
        cursor: pointer;
        height: 28px;
        width: 28px;
        margin: 10px 0 0 476px;
        border-radius: 50%;
        // border: 1px solid #009dd9;
      }
    }
  }

  .floatNew {
    background: url("../../assets/images/xiaotc.png") no-repeat center;
    height: 120px;
    width: 138px;
    // background: rgb(194, 235, 254);
    position: fixed;
    right: 30px;
    bottom: 30px;
    border-radius: 12px;

    .floatBtn {
      margin: 72px 0 0 10px;
      width: 125px;
      height: 40px;
      border-radius: 16px;
      opacity: 0;
    }
  }
}
</style>
